import {api2Endpoint} from 'app/config/apiConfig'
import {getData} from 'app/hooks/api/useGetData'
import {announceReturn, announceSend} from 'app/hooks/api/utils/announce'
import {JsonObject, cloneJson} from 'utilities/types'
import {IUserFile} from '../'
import {CBaseRecord} from './_base'

export class CUserFile extends CBaseRecord<IUserFile> implements IUserFile {
  static record_name = 'user_file'
  static external_id = 'user_file_id'

  id
  s3_key
  etag
  extension
  note_id
  is_public
  name
  directory
  size
  tenant_id
  upload_pending

  constructor(data: IUserFile & JsonObject) {
    super(data)
    this.id = data.id
    this.s3_key = data.s3_key
    this.etag = data.etag
    this.extension = data.extension
    this.note_id = data.note_id
    this.is_public = data.is_public || false
    this.name = data.name
    this.directory = data.directory
    this.size = data.size
    this.tenant_id = data.tenant_id
    this.upload_pending = data.upload_pending
  }

  get downloadLinkUrl() {
    if (this.note_id !== undefined && this.note_id !== null) {
      return `std/user_file/${this.id}`
    }
    return `std/${this.s3_key}`
  }

  async download() {
    // This is the rare case where we do this outside of a hook.
    // The reason is that download links expire very quickly (potentially on the order of
    // seconds), so we don't want to retrieve the link until the moment it's needed.
    const method = 'get'
    const route = this.downloadLinkUrl
    announceSend(method, route)
    // TEST
    const downloadLink: string = await getData<string>(api2Endpoint(route))
    announceReturn(method, route)
    if (downloadLink) {
      window.location.href = downloadLink
    } else {
      throw new Error('Unable to download file.')
    }
  }

  export() {
    return {
      id: this.id,
      created: cloneJson(this.created),
      updated: cloneJson(this.updated),
      etag: this.etag,
      extension: this.extension,
      note_id: this.note_id,
      is_public: this.is_public,
      name: this.name,
      directory: this.directory,
      size: this.size,
      tenant_id: this.tenant_id,
      upload_pending: this.upload_pending,
    }
  }
}
